<!-- Common Container starts -->
<section class="wrapper">
    <div class="tracker-info-form">
        <h4 class="form-title">HOME</h4>
        <div class="responsive-grid">
            <div class="grid-row clearfix">
                <div class="col-25">
                    <button class="btn btn-primary ml-10" (click)="redirectPath('/dashboard')">Model Maintenance</button>
                </div>
                <div class="col-25">
                    <button class="btn btn-primary ml-10" (click)="redirectPath('/cases-used')">Cases Used</button>
                </div>
                <div class="col-25">
                    <button class="btn btn-primary ml-10" (click)="redirectPath('/pieces-used')">Pieces Used</button>
                </div>
                <div class="col-25">
                    <button class="btn btn-primary ml-10" (click)="redirectPath('/inventory-adjustments')">Inventory Adjustment</button>
                </div>
            </div>
        </div>
    </div>

</section>
<!-- Common Container ends -->